import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class AcceptedStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 100 100"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2="100%">
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#A1D297"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#418349"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<polygon points="0,70 15,55 35,75 85,0 100,15 35,100" className="movearea"
                                 onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
								 onPointerDown={this.props.onMoveStart}/>
					}
					<polygon points="0,70 15,55 35,75 85,0 100,15 35,100" style={{
						fill: "#A1D297",
						strokeWidth: 5,
						stroke: "#418349"
					}}/>
				</g>
			</svg>
		);
	}
}